class Shipment {
  constructor(json) {
    this.json = json;
    this.insured = json.insured;
    this.signatureRequired = json.signature_required;
    this.mediaMailQualified = json.media_mail_qualified;
    this.mediaMailEligible = json.media_mail_eligible;
    this.needsCustoms = json.needsCustoms;
  }
}

module.exports = Shipment;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/shipment.js